export default {
    leaveOnsite: 'Leave / Onsite',
    Onsite: 'Onsite',
    Leave: 'Leave',
    leaveType: 'Leave Type',
    selectType: '- Select type -',
    choice: 'Choice',
    singleDay: 'Single day',
    range: 'Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    time: 'Time',
    selectPeriodType: '- Select period type -',
    attachFile: 'Attach File',
    fileImage: 'File / Image',
    reason: 'Reason',
    reasonMsg: 'Detail of your leave',
    cancel: 'Cancel',
    submit: 'Submit',
    fieldRequired: 'This field is required',
    fieldLessThanCharacters: 'This field should be less than 255 characters',
    msgSuccessSingleDay: 'Your application success at $startDate',
    msgSuccessRange: 'Your application success at $startDate to $endDate',
    cannotGetLineId: 'Cannot get line user id',
    approve: 'Approve',
    reject: 'Reject',
    back: 'back'
}
